import * as _ from 'underscore'

import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { PopupType } from '../../../helpers/popup-manager'
import { LocalizationHelper, ToastHelper, LogHelper } from '../../../helpers'

import { DistributorService } from '../../../services/distributor'
import { UserSessionService } from '../../../services/user-session'
import { DistributorRoleService } from '../../../services/distributor'

import { IMRSelectGridPopupOptions, IIMRSelectGridPopup, IMRSelectGridPopupInitializedArgs } from '../../common/select-grid/popup'

import { GridTypes } from '../../common/grid/grid.controller'
import { CreateEditScope, CreateEditController } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { Enums } from '../../../models/common'
import { OpDistributor, OpDistributorData, OpRole, OpOperator } from '../../../models/core'
import { IOpObject } from '../../../models/util/interfaces'
import { OpDataList } from '../../../models/util'
import { IMRSelectGridObjectsSelected } from 'app/modules/common/select-grid'


interface DistributorCreateEditScope extends CreateEditScope {
    editedItem: any
    id: number

    isCreateEditAdditionalFields: boolean
}

export class DistributorCreateEditController extends CreateEditController {

    //#region Members

    private deffererRole: ng.IDeferred<OpRole[]>

    public rolesSelectPopupOptions: IMRSelectGridPopupOptions<OpRole>
    private rolesSelectGridPopup: IIMRSelectGridPopup<OpRole>
    currentRoles: OpRole[]

    //#endregion


    //#region Ctor

    public constructor(
        private $scope: DistributorCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private distributorService: DistributorService,
        private distributorRoleService: DistributorRoleService,
        private userSession: UserSessionService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenceType)

        this.setEvents()
        this.setOptions()
        this.setRolesGridOptions()
    }

    //#endregion


    //#region Events

    public onInit(args: any[]): void {
        if (args && args[0]) {
            var createEditInitParams: CreateEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            this.$scope.popupType = PopupType.CREATE_EDIT_POPUP

            if (createEditInitParams.referenceObject && createEditInitParams.referenceObject.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams, 1)
            })
        }
    }

    public onInitBulk(args: any[]): void {
        if (args && args[0]) {
            var bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.popupType = PopupType.BULK_EDIT_POPUP

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const distributorToSave: OpDistributor = OpDistributor.fromIOpObject(objectToSave)
        const deferred = this.$q.defer<IOpObject>()

        this.getRolesToAssignDistributor(distributorToSave)
            .then((roles: OpRole[]) => {
                if (roles != null) {
                    const roleData: OpDataList<OpDistributorData> = this.distributorRoleService.createDistributorDataFromOpRoles(roles)

                    distributorToSave.dataList.push(...roleData.toArray())

                    this.distributorService
                        .saveDistributor(distributorToSave)
                        .then((savedObject: OpDistributor) => {
                            this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                            deferred.resolve(savedObject)
                        })
                        .fail((error: any) => {

                            deferred.reject(error)
                        })
                }
                else {
                    deferred.reject()
                }
            })

        return deferred.promise
    }

    public onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const distributorToSave: OpDistributor = OpDistributor.fromIOpObject(objectToSave)
        const deferred = this.$q.defer<IOpObject>()

        this.distributorService
            .saveDistributor(distributorToSave, true)
            .then((savedObject: OpDistributor) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    //#endregion


    //#region Setup

    public setEvents(): void {
        this.$scope.$on(EventsNames.DISTRIBUTOR_OPEN_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) })
        this.$scope.$on(EventsNames.DISTRIBUTOR_OPEN_BULK_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInitBulk(args) })
    }

    public setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.isCreateEditAdditionalFields = true
        this.$scope.options = {
            title: "",
            type: PopupType.DISTRIBUTOR_POPUP,//NIE UŻYWAĆ!!!
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
            onClose: null,
            onSubmit: null,//DO USUNIECIA!!!
            submitBulkEdit: null,//DO USUNIECIA!!!
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.distributorSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    //#endregion


    //#region Roles

    private setRolesGridOptions(): void {
        this.rolesSelectPopupOptions = {
            selectGridOptions: {
                multiSelect: true,
                required: true,

                gridOptions: {
                    name: null,
                    type: GridTypes.NO_SEARCH_BAR_SMALL_SINGLE_PAGE,
                    buttonsOptions: {
                        enabled: false
                    },
                    columns: [
                        {
                            dataField: 'name',
                            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Roles),
                            allowEditing: false,
                            dataType: 'string'
                        }
                    ],
                    scrolling: {
                        mode: 'virtual'
                    },

                    selection: {
                        showCheckBoxesMode: 'always',
                    },

                    getDataSource: () => {
                        return this.currentRoles || []
                    },

                    onToolbarPreparing: e => {
                        e.toolbarOptions.visible = false
                    },
                },

                onObjectsSelected: (e: IMRSelectGridObjectsSelected<OpRole>) => {
                    this.deffererRole.resolve(e.selectedObjects)
                }
            },

            popupOptions: {
                innerOptions: {
                    closeOnOutsideClick: true,
                    dragEnabled: false,
                    height: 500,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignDistributorToRole),
                    width: 500,

                    onHidden: () => this.deffererRole.resolve(null)
                }
            },

            onInitialized: (e: IMRSelectGridPopupInitializedArgs<OpRole>) => {
                this.rolesSelectGridPopup = e.component
            }
        }
    }

    private showRolesGrid(roles: OpRole[]): void {
        this.currentRoles = roles
        this.rolesSelectGridPopup.getPopup().show()
    }

    private getRolesToAssignDistributor(distributor: OpDistributor): ng.IPromise<OpRole[]> {
        this.deffererRole = this.$q.defer<OpRole[]>()
        this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)

        if (distributor != null && distributor.idDistributor == 0) {
            const loggedOperator: OpOperator = this.userSession.getLoggedOperator()

            if (loggedOperator != null) {
                const userRoles: OpRole[] = loggedOperator.roles

                if (_.size(userRoles)) {
                    if (userRoles.length > 1) {
                        this.showRolesGrid(userRoles)
                    }
                    else {
                        this.deffererRole.resolve(userRoles)
                    }
                } else {
                    this.deffererRole.resolve([])
                }
            }
            else {
                ToastHelper.showInfo(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVE_ERROR, DistributorService.SIMAX_MODULE_NAME))
                LogHelper.warn(DistributorService.LOG_PREFIX, 'Unable to find logged operator.')

                this.deffererRole.resolve([])
            }
        } else {
            this.deffererRole.resolve([])
        }

        return this.deffererRole.promise.then(result => {
            this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)

            return result
        })
    }

    //#endregion
}